


































































































































import { StoreManagementStoreService } from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import _ from "lodash";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "EditSaleItemsComponent",
  components: {
    QCalendar,
    QErrors,
  },
})
export default class EditSaleItemsComponent extends Vue {
  public name: "EditSaleItemsComponent";

  @Prop({
    type: Object,
    default: null,
  })
  public error;

  @Prop({
    type: Number,
    default: null,
  })
  public saleId;

  @Prop({
    type: Array,
    default: [],
  })
  public saleList;

  public errors = {};
  public startTime = null;
  public endTime = null;
  public sales = [];
  public id = "";
  public editingSale = false;
  public deleteIds = [];
  public newSaleOrigin = {
    code: null,
    start_date: null,
    end_date: null,
  };
  public saleErrors = {};

  public config = {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    defaultHour: 0,
    allowInput: false,
  };

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }

  public clearSale() {
    this.startTime = null;
    this.endTime = null;
  }

  public async getSales() {
    const result = await StoreManagementStoreService.adminStoreListSale({});
    this.sales = result.data.sales;
  }

  public removeSale(index) {
    this.deleteIds.push(this.sales[index].id);
    this.sales.splice(index, 1);
  }

  public addSale() {
    this.sales.push(_.cloneDeep(this.newSaleOrigin));
  }

  public changeSale() {
    this.clearSale();
    const saleListData = this.sales.find(function(value) {
      return value.id === this;
    }, this.id);
    if (!saleListData) {
      this.id = "";
    } else {
      this.startTime = this.formatJpDate(saleListData.start_date);
      this.endTime = this.formatJpDate(saleListData.end_date);
    }
    this.changeSelect();
  }

  public formatJpDate(date) {
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  }

  public changeSelect() {
    let selectId;
    if (this.id === "") {
      selectId = null;
    } else {
      selectId = Number(this.id);
    }
    this.$emit("change-select-id", selectId);
  }

  public showSalePopup() {
    this.editingSale = true;
  }

  public confirmCancel() {
    if (_.isEqual(this.sales, this.saleList)) {
      this.cancelEditSale();
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.cancelEditSale();
        },
      });
    }
  }

  public cancelEditSale() {
    this.editingSale = false;
    this.deleteIds = [];
    this.saleErrors = {};
    this.getSales();
  }

  public async syncSales() {
    this.saleErrors = {};
    let result;
    const data = [];

    data.push(...this.sales);

    try {
      result = await StoreManagementStoreService.adminStoreSale({
        sales: data,
        deleteIds: this.deleteIds,
      });
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.cancelEditSale();
        this.changeSaleId();
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.saleErrors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
    }
  }

  @Watch("error")
  public changeError() {
    this.errors = this.error;
  }

  @Watch("saleList")
  public changeSaleList() {
    this.sales = _.cloneDeep(this.saleList);
  }

  @Watch("saleId")
  public changeSaleId() {
    if (this.saleId) {
      this.id = this.saleId === null ? "" : this.saleId;
      this.changeSale();
    }
  }
}
